import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import AnalyticsActionTypes from 'yoda-site-components/lib/actionTypes/AnalyticsActionTypes';
import { MARKETING_PAGE_LOAD } from '../actionTypes/MarketingActionTypes';
import constants from '../analytics/Marketing.config';

const buildPageViewPayload = (state, payload = {}) => {
    const context = state.context || {};
    const { pageType = '', pageName = '' } = payload;

    return buildCJAPageViewPayload({
        name: pageName || `d:${constants.siteSection.MARKETING}`,
        type: pageType,
        siteSection: constants.siteSection.MARKETING,
        category: {
            primary: constants.siteSection.MARKETING,
        },
        flags: {
            isErrorPage: !!state.ErrorPage,
        },
        tech: {
            releaseVersion: context.__RELEASEVERSION__ || '',
            version: 'apollo 1 marketing',
        },
    });
};

const getCurrentPageUrl = () => window.location.pathname;

const buildLinkClickPayload = ({
    linkComponent = '',
    linkId = '',
    linkText = '',
    linkType = 'other',
    linkModuleName = '',
    linkRegion = '',
    linkPosition = 0,
} = {}) => ({
    event: 'linkClick',
    event_name: 'linkClick',
    linkComponent,
    linkId,
    linkText,
    linkType,
    linkUrl: getCurrentPageUrl(),
    linkModuleName,
    linkRegion,
    linkPosition,
});

const buildShopTheLookPayload = (payload = {}) =>
    buildLinkClickPayload({
        linkComponent: 'shopTheLook',
        linkId: payload.shopTheLookID || '',
        linkText: payload.linkText || '',
        linkModuleName: `shopTheLook:${payload.shopTheLookID}`,
        linkRegion: payload.pageName || '',
        linkPosition: payload.linkPosition ?? 0,
    });

const buildShopTheLookDetailPayload = (payload = {}) =>
    buildLinkClickPayload({
        linkComponent: 'shopTheLookDetail',
        linkId: payload.shopTheLookID || '',
        linkText: payload.linkText || '',
        linkModuleName: `shopTheLook:${payload.shopTheLookID}:${payload.shopTheLookPPID}`,
        linkRegion: 'mini pdp',
        linkPosition: payload.linkPosition ?? 0,
    });

let cjaPageViewFired = false;

const CJAMiddleware = (store) => (next) => (action) => {
    if (typeof window === 'undefined') return next(action);
    if (!cjaAnalytics.isEnabled()) return next(action);

    const state = store.getState();
    let eventName = null;
    let eventData = null;

    switch (action.type) {
        case MARKETING_PAGE_LOAD:
            if (cjaPageViewFired) break;
            eventName = 'pageView';
            eventData = buildPageViewPayload(state, action.payload);
            cjaPageViewFired = true;
            break;
        case AnalyticsActionTypes.PDP_SHOP_THIS_LOOK_CLICK_EVENT:
            eventName = 'linkClick';
            eventData = buildShopTheLookPayload({
                ...action.payload,
                pageName: constants.siteSection.MARKETING,
            });
            break;
        case AnalyticsActionTypes.PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT:
            eventName = 'linkClick';
            eventData = buildShopTheLookDetailPayload(action.payload);
            break;
        default:
            break;
    }

    if (eventName && eventData) {
        cjaAnalytics.track(eventName, eventData);
    }

    return next(action);
};

export default CJAMiddleware;
